import { createPlugin, key } from './pm-plugins/main';
export var interactionPlugin = function interactionPlugin(_ref) {
  var api = _ref.api;
  return {
    name: 'interaction',
    getSharedState: function getSharedState(editorState) {
      var _key$getState;
      if (!editorState) {
        return {
          hasHadInteraction: false
        };
      }
      return {
        hasHadInteraction: Boolean((_key$getState = key.getState(editorState)) === null || _key$getState === void 0 ? void 0 : _key$getState.hasHadInteraction)
      };
    },
    pmPlugins: function pmPlugins() {
      return [{
        name: 'interactionHandlerPlugin',
        plugin: createPlugin
      }];
    }
  };
};